module.exports = __webpack_public_path__ + "media/damages/szkoda-2@2x-9eb60c60.png";